import { render, staticRenderFns } from "./EFormEscola.vue?vue&type=template&id=5d192da1"
import script from "./EFormEscola.vue?vue&type=script&lang=js"
export * from "./EFormEscola.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports